const API_BASE =
  (typeof process !== 'undefined' &&
    process.env &&
    (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE)) ||
  'http://localhost:5000/api';

/**
 * Fetch a short-lived (10 min) single-file token and return the full
 * preview URL. The session JWT never appears in the URL. Returns null on
 * any failure so callers can fall back.
 */
export async function getFilePreviewUrl(path) {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const res = await fetch(`${API_BASE.replace(/\/$/, '')}/auth/file-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ url: path })
    });
    if (!res.ok) return null;
    const data = await res.json();
    if (!data.token) return null;
    return `${API_BASE.replace(/\/$/, '')}${path}?token=${data.token}`;
  } catch {
    return null;
  }
}
